import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#080808] text-white p-8 mt-auto" style={{ borderTop: '1px solid rgba(155,240,30,0.22)' }}>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="font-bold text-sm tracking-widest uppercase mb-4" style={{ color: '#9bf01e' }}>Smuglergods</h3>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.38)' }}>Vi leverer den beste drittmusikken siden 2023.</p>
          </div>
          <div>
            <h4 className="font-bold text-sm tracking-widest uppercase mb-4" style={{ color: '#9bf01e' }}>Følg oss</h4>
            <ul className="space-y-2">
              <li><a href="https://instagram.com" className="link-secondary text-sm">Instagram</a></li>
              <li><a href="https://facebook.com" className="link-secondary text-sm">Facebook</a></li>
              <li><a href="https://youtube.com" className="link-secondary text-sm">YouTube</a></li>
              <li><a href="https://spotify.com" className="link-secondary text-sm">Spotify</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-sm tracking-widest uppercase mb-4" style={{ color: '#9bf01e' }}>Lenker</h4>
            <ul className="space-y-2">
              <li><a href="/about" className="link-secondary text-sm">Om</a></li>
              <li><a href="/events" className="link-secondary text-sm">Arrangementer</a></li>
              <li><a href="/musikk" className="link-secondary text-sm">Musikk</a></li>
              <li><a href="/contact" className="link-secondary text-sm">Kontakt oss</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-sm tracking-widest uppercase mb-4" style={{ color: '#9bf01e' }}>Nyhetsbrev</h4>
            <p className="text-sm mb-3 leading-relaxed" style={{ color: 'rgba(255,255,255,0.38)' }}>Meld deg på for oppdateringer og eksklusivt innhold.</p>
            <div className="flex">
              <input 
                type="email" 
                placeholder="Din e-post" 
                className="input-glow flex-1 text-sm"
              />
              <button className="bg-neon-green text-black px-4 py-2 text-sm font-bold tracking-wide hover:bg-white transition-colors">
                OK
              </button>
            </div>
          </div>
        </div>
        
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center" style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}>
          <p className="text-xs opacity-30">© {currentYear} Smuglergods. Alle rettigheter reservert.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="/privacy" className="link-secondary text-xs">Personvern</a>
            <a href="/terms" className="link-secondary text-xs">Bruksvilkår</a>
            <a href="/contact" className="link-secondary text-xs">Kontakt</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 